export default "__VITE_ASSET__B2MBzr6L__"